<template>
    <div>
        <v-card class="">
            <person-vehicles-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonVehiclesTable from './PersonVehiclesTable';

    export default {

        name: "Vehicle",

        components: {
            PersonVehiclesTable
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                panel: [true]
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
    #personVehicles {
        font-size: 14px;
    }

    .personVehicleTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
